<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

<div class="row h-100 ">
  <div class="col-md-12 my-auto">
<div class="row justify-content-center">
  <div class="col-md-3">
      <div class="card">
        <div class="content-body">
<h2 class="h4 mt-0 mb-1">Sign up</h2>
<p [tcColor]="'#8f8f90'">Create your Account</p>

<register-form></register-form>

<!-- <!-- <p class="mt-5">Have an account? <a [routerLink]="['../', 'sign-in']">Sign in!</a></p> -->
</div>
</div>

</div>
</div>
</div>
</div>